var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFileUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3963_57911",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3963_57911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9165 18.3846H13.4165V13.9499L15.2665 15.7999L16.3203 14.7307L12.6665 11.0769L9.01265 14.7307L10.0819 15.7846L11.9165 13.9499V18.3846ZM6.9742 21.5C6.46907 21.5 6.0415 21.325 5.6915 20.975C5.3415 20.625 5.1665 20.1974 5.1665 19.6923V4.3077C5.1665 3.80257 5.3415 3.375 5.6915 3.025C6.0415 2.675 6.46907 2.5 6.9742 2.5H14.9165L20.1665 7.74995V19.6923C20.1665 20.1974 19.9915 20.625 19.6415 20.975C19.2915 21.325 18.8639 21.5 18.3588 21.5H6.9742ZM14.1665 8.49995V3.99998H6.9742C6.89727 3.99998 6.82675 4.03203 6.76263 4.09613C6.69853 4.16024 6.66648 4.23077 6.66648 4.3077V19.6923C6.66648 19.7692 6.69853 19.8397 6.76263 19.9038C6.82675 19.9679 6.89727 20 6.9742 20H18.3588C18.4357 20 18.5062 19.9679 18.5703 19.9038C18.6344 19.8397 18.6665 19.7692 18.6665 19.6923V8.49995H14.1665Z",
    fill: "#DDDDDD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFileUpload);
export default __webpack_public_path__ + "static/media/icFileUpload.348fa4ed796b09d494cda5af0fc8c245.svg";
export { ForwardRef as ReactComponent };